import { IconTrashOutline18 as TrashIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const tableRemoveColumnCommand: SlashCommandDefinition = {
	key: "table-remove-column",
	title: "Remove Column from Table",
	icon: <TrashIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).deleteColumn().run()
	},
	group: "table",
}
